// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"2d9a4029","221":"4491726b","570":"316132fb"}[chunkId] + ".chunk.css";
};